export const BLOG_URL = "https://blog.nhoxanboc.work/";
